export const getDefaultPopoverStyles = (theme: any) =>
   `
   ${theme.popover.background} 
   border ${theme.popover.borderColor} rounded-12px
   shadow-xl
   `
